<template>
  <div class="uc-my-recmd bShadow-5">
    <el-tabs @tab-click="tabClick" value="1" class="ui-tabs ui-custom-s">
      <el-tab-pane name="1">
        <span slot="label" class="lb-txt"> 风险评估 </span>
        <Risk v-if="status == 1" :cxlx='1'></Risk>
      </el-tab-pane>
      <el-tab-pane name="2" class="or-inf">
        <span slot="label" class="lb-txt">历史记录</span>
        <Risk v-if="status == 2" :cxlx='2'></Risk>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Risk from '@/components/risk'
export default {
  name: 'recommend',
  props: {},
  components: {
    Risk,
  },
  data() {
    return {
      status: 1,
    }
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    tabClick(option) {
      this.status = option.name
    },
  },
}
</script>

<style lang="stylus" scoped>








.uc-my-recmd {
  height: 666px;
  box-sizing: border-box;
  background-color: #F2F4F8;
  overflow: hidden;
}

</style>
